import { createSlice } from '@reduxjs/toolkit';
import { bool } from 'prop-types';

const initialState = {
    patientProfile: {},
    currentSession: {},
    queuedData: {},
    inboxMessages: [],
    engagedData:{},
    appointmentData:{},
    // manageCallData:{},
    closeChatData:{},
    nextMode:{},

}

const slice = createSlice({
    name: 'mentalHealth',
    initialState: initialState,
    reducers: {
        setPatientProfile: (state, action) => {
            state.patientProfile = action.payload;
        },
        setCurrentSession: (state, action) => {
            state.currentSession = action.payload;
        },
        setQueuedData: (state, action) => {
            state.queuedData = action.payload;
        },
        setInboxMessages: (state, action) => {
            state.inboxMessages = action.payload;
        },
        setNextMode: (state, action) => {
            state.nextMode = action.payload;
        },
        setEngagedData: (state, action) => {
            state.engagedData = action.payload;
        },
        setAppointmentData: (state, action) => {
            state.appointmentData = action.payload;
        },
        // setManageCallData: (state, action) => {
        //     state.manageCallData = action.payload;
        // },
        setCloseChatData: (state, action) => {
            state.closeChatData = action.payload;
        }
    },
});

export const addPatientData = (key) => (dispatch) => {
    try {
        dispatch(
            slice.actions.setPatientProfile(key || null),
        )
    } catch (e) {
        console.log(e)
    }
}

export const addCurrentSession = (key) => (dispatch) => {
    try {
        dispatch(
            slice.actions.setCurrentSession(key || null),
        )
    } catch (e) {
        console.log(e)
    }
}

export const addQueuedData = (key) => (dispatch) => {
    try {
        dispatch(
            slice.actions.setQueuedData(key || null),
        )
    } catch (e) {
        console.log(e)
    }
}

export const addAppointmentData = (key) => (dispatch) => {
    try {
        dispatch(
            slice.actions.setAppointmentData(key || null),
        )
    } catch (e) {
        console.log(e)
    }
}
export const showCloseChatTag = (key) => (dispatch) => {
    try {
        dispatch(
            slice.actions.setCloseChatData(key || null),
        )
    } catch (e) {
        console.log(e)
    }
}

export const addEngagedPatient = (key) => (dispatch) => {
    try {
        dispatch(
            slice.actions.setEngagedData(key || null),
        )
    } catch (e) {
        console.log(e)
    }
}

export const addInboxMessages = (key) => (dispatch) => {
    try {
        dispatch(
            slice.actions.setInboxMessages(key || null),
        )
    } catch (e) {
        console.log(e)
    }
}

export const addNextMode = (key) => (dispatch) => {
    try {
        dispatch(
            slice.actions.setNextMode(key || null),
        )
    } catch (e) {
        console.log(e)
    }
}

// export const manageCall = (key) => (dispatch) => {
//     try {
//         dispatch(
//             slice.actions.setManageCallData(key || null),
//         )
//     } catch (e) {
//         console.log(e)
//     }
// }

export const actions = {
    ...slice.actions,
    addPatientData,
    addCurrentSession,
    addQueuedData,
    addInboxMessages,
    addEngagedPatient,
    addAppointmentData,
    // manageCall,
    showCloseChatTag
}

export default slice.reducer;